import { ReactElement } from 'react';
import { RelatedObjectCounts } from './types';
import { Box, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { WrappedIcon } from 'components/Icon';

export function RelatedEntites({ related }: { related: RelatedObjectCounts }): ReactElement | null {
  if (Object.keys(related).length === 0) {
    return null;
  }
  return (
    <PopoverRoot>
      <PopoverTrigger openOnHover>
        <WrappedIcon icon="link" role="button" aria-label="Related entities" />
      </PopoverTrigger>
      <PopoverPopup>
        <Box p="3" fontSize="sm">
          {Object.entries(related).map(([key, count]) => (
            <Box key={key} display="flex" py="1">
              <Box>{key}</Box>
              <Box fontWeight="bold" marginLeft="auto" pl="3">
                {count}
              </Box>
            </Box>
          ))}
        </Box>
      </PopoverPopup>
    </PopoverRoot>
  );
}
